export default "__VITE_ASSET__BO1PXqu0__"